/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationsGetOnboardingStatus } from "../funcs/organizationsGetOnboardingStatus.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { OnboardingStatusResult } from "../models/components/onboardingstatusresult.js";
import {
  GetOnboardingStatusRequest,
  GetOnboardingStatusSecurity,
} from "../models/operations/getonboardingstatus.js";
import { unwrapAsync } from "../types/fp.js";
export type OnboardingStatusQueryData = OnboardingStatusResult;

export function prefetchOnboardingStatus(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetOnboardingStatusRequest | undefined,
  security?: GetOnboardingStatusSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildOnboardingStatusQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildOnboardingStatusQuery(
  client$: GramCore,
  request?: GetOnboardingStatusRequest | undefined,
  security?: GetOnboardingStatusSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<OnboardingStatusQueryData>;
} {
  return {
    queryKey: queryKeyOnboardingStatus({ gramSession: request?.gramSession }),
    queryFn: async function onboardingStatusQueryFn(
      ctx,
    ): Promise<OnboardingStatusQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(organizationsGetOnboardingStatus(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyOnboardingStatus(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "organizations", "getOnboardingStatus", parameters];
}
